<!-- eslint-disable prettier/prettier -->
<div class="register-page">
	<div class="reg-wrap">
		<div class="reg-card">
			@if (registroCompletado()) {

			<app-register-success [email]="emailRegistrado()" />

			} @else {

			<mat-stepper #stepper [linear]="true" orientation="horizontal" class="reg-stepper">
				<!-- ─── Paso 1: RENAPER ──────────────────────────────────────── -->
				<mat-step label="Verificación" [completed]="step1Completed()" [editable]="false">
					<div class="step-body">
						<app-register-renaper
							[hasError]="autenticarError()"
							(renaperValidated)="onRenaperValidated($event)"
						/>
					</div>
				</mat-step>

				<!-- ─── Paso 2: Información personales ────────────────────────────── -->
				<mat-step
					label="Información personal"
					[completed]="step2Completed()"
					[editable]="step1Completed()"
				>
					<div class="step-body">
						<p class="step-section-title">Información personal</p>

						<app-register-personal-info
							[requestForm]="requestPersonalInfo"
							[userData]="renaperData"
							(formData)="onPersonalInfoChange($event)"
						/>

						<div class="step-actions">
							<button
								mat-flat-button
								class="step-btn step-btn--next"
								(click)="tryNextFromPersonalInfo()"
							>
								<span class="step-btn__inner">
									Siguiente
									<lucide-icon
										name="arrow-right"
										[size]="24"
										[strokeWidth]="2"
										color="#ffffff"
									></lucide-icon>
								</span>
							</button>
						</div>
					</div>
				</mat-step>

				<!-- ─── Paso 3: Domicilio ────────────────────────────────────── -->
				<mat-step
					label="Domicilio"
					[completed]="step3Completed()"
					[editable]="step1Completed()"
				>
					<div class="step-body">
						<p class="step-section-title">Domicilio</p>

						<app-register-address
							#addressStep
							[requestForm]="requestAddresses"
							(addressChange)="onAddressChange($event)"
						/>

						<div class="step-actions">
							<button
								mat-stroked-button
								matStepperPrevious
								class="step-btn step-btn--back"
							>
								<span class="step-btn__inner">
									<lucide-icon
										name="arrow-left"
										[size]="24"
										[strokeWidth]="2"
										color="#5F1F7B"
									></lucide-icon>
									Atrás
								</span>
							</button>
							<button
								mat-flat-button
								class="step-btn step-btn--next"
								(click)="tryNextFromAddress()"
							>
								<span class="step-btn__inner">
									Siguiente
									<lucide-icon
										name="arrow-right"
										[size]="24"
										[strokeWidth]="2"
										color="#ffffff"
									></lucide-icon>
								</span>
							</button>
						</div>
					</div>
				</mat-step>

				<!-- ─── Paso 4: Datos de contacto ────────────────────────────── -->
				<mat-step label="Datos de contacto" [editable]="step1Completed()">
					<div class="step-body">
						<p class="step-section-title">Datos de contacto</p>

						<app-register-access #accessStep (submitRegister)="onSubmitRegister()" />

						<div class="step-actions">
							<button
								mat-stroked-button
								matStepperPrevious
								class="step-btn step-btn--back"
							>
								<span class="step-btn__inner">
									<lucide-icon
										name="arrow-left"
										[size]="24"
										[strokeWidth]="2"
										color="#5F1F7B"
									></lucide-icon>
									Atrás
								</span>
							</button>
							<button
								mat-flat-button
								class="step-btn step-btn--submit"
								(click)="handleFinalSubmit()"
								[disabled]="accessComponent?.loading()"
							>
								<span class="step-btn__inner">
									@if (accessComponent?.loading()) {
									<lucide-icon
										name="refresh-cw"
										[size]="24"
										[strokeWidth]="2"
										color="#ffffff"
										class="spin"
									></lucide-icon>
									Registrando... } @else { Registrarme }
								</span>
							</button>
						</div>
					</div>
				</mat-step>
			</mat-stepper>

			}
		</div>
	</div>
</div>
